/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_RebookInputs */

const en_orders_rebook = /** @type {(inputs: Orders_RebookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebook`)
};

const es_orders_rebook = /** @type {(inputs: Orders_RebookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a reservar`)
};

/**
* | output |
* | --- |
* | "Rebook" |
*
* @param {Orders_RebookInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_rebook = /** @type {((inputs?: Orders_RebookInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_RebookInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_rebook(inputs)
	return es_orders_rebook(inputs)
});